export const cancelamentoListConstants = {
  CANCELAMENTO_LIST_REQUEST: 'CANCELAMENTO_LIST_REQUEST',
  CANCELAMENTO_LIST_SUCCESS: 'CANCELAMENTO_LIST_SUCCESS',
  CANCELAMENTO_LIST_FAILURE: 'CANCELAMENTO_LIST_FAILURE',
};
